
/**
 * This is used for integration with Hilton's Fusion application
 * For testing, navigate to: /#/internal/connector
 * See also: MessagingModule, ConnectorModule
 */

import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { L10nTranslationService } from 'angular-l10n';
import { UserApi } from '../../hickory-api';
import { WindowMessage, WindowMessageService } from './window-message.service';

@Injectable()
export class UserDataService {
  private isInitialized: boolean = false;

  constructor(
    private messageService: WindowMessageService,
    private translation: L10nTranslationService,
    private router: Router,
    private route: ActivatedRoute,
    private snackbar: MatSnackBar,
    private userApi: UserApi
  ) { }

  initialize() {
    if (!this.isInitialized) {
      this.isInitialized = true;

      // listen for changes to the route query params, watching for the "UserDataId" key
      this.route.queryParams.subscribe((params: Params) => {
        const paramKey = Object.keys(params).find(k => k.toLowerCase() === 'userdataid');
        const paramValue = paramKey ? params[paramKey] : null;
        if (paramValue) {
          this.loadMessage(paramValue);
        }
      });
    }
  }

  loadMessage(id: string) {
    this.userApi.getJsonById(id).subscribe(r => {
      if (r.isValid) {
        const message = r.item.json as WindowMessage;
        this.messageService.processMessage(message);
        this.removeMessage(r.item.id);
      }
    }, _err => {
      // Unable to retrieve message, can't perform action
      this.showSnackbar(this.translation.translate('NoDataFoundForId') + id);

      // navigate to the dashboard instead
      this.router.navigate(['/dashboard']);
    });
  }

  removeMessage(id: string) {
    this.userApi.deleteJson(id).subscribe();
  }

  showSnackbar(message: string) {
    const config = new MatSnackBarConfig;
    config.duration = 5000;
    config.horizontalPosition = 'center';
    config.verticalPosition = 'top';
    this.snackbar.open(message, null, config);
  }
}
